var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.96434 1.43943C6.38848 2.01528 5.81785 2.28263 4.99687 2.28263C4.28004 2.28263 3.26018 2.14361 2.7 2.7085C2.14424 3.26893 2.28265 4.28459 2.28265 4.99685C2.28265 5.81785 2.01528 6.38849 1.43942 6.96435C0.479812 7.92396 8.29369e-06 8.40376 0 8.99998C1.47571e-05 9.5962 0.479823 10.0761 1.43944 11.0357C2.08454 11.6807 2.28265 12.0973 2.28265 13.0031C2.28265 13.72 2.14363 14.7398 2.70854 15.3C3.26897 15.8557 4.28461 15.7173 4.99686 15.7173C5.87114 15.7173 6.29216 15.8884 6.91611 16.5123C7.44743 17.0436 8.15967 18 9.00002 18C9.84036 18 10.5526 17.0436 11.0839 16.5123C11.7078 15.8884 12.1289 15.7173 13.0031 15.7173C13.7154 15.7173 14.731 15.8557 15.2915 15.3C15.8564 14.7398 15.7173 13.72 15.7173 13.0031C15.7173 12.0973 15.9154 11.6807 16.5606 11.0357C17.5202 10.0761 18 9.5962 18 8.99998C18 8.40376 17.5202 7.92396 16.5606 6.96435C15.9155 6.31924 15.7173 5.90272 15.7173 4.99685C15.7173 4.28003 15.8564 3.26019 15.2915 2.7C14.7311 2.14422 13.7154 2.28263 13.0031 2.28263C12.1819 2.28263 11.6114 2.01516 11.0357 1.43943C10.076 0.479811 9.59623 1.71594e-07 9 0C8.40377 2.28792e-07 7.92396 0.479811 6.96434 1.43943Z",
    fill: "#32E886"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(5,6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.589844 3.81206C0.589844 3.81206 1.95405 4.40486 2.63616 5.27372C2.63616 5.27372 4.68248 1.86319 7.4109 0.726349",
    stroke: "#141B34",
    strokeWidth: 1.1875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.0d378e1bdf62839d4951853b689bad3e.svg";
export { ForwardRef as ReactComponent };